import type { ConnectionState } from '@/common/real-time-communication/domain/connection/ConnectionState';

export class ClientStateChanged {
  static readonly eventName = 'RealTimeCommunication:ClientStateChanged';

  readonly name = ClientStateChanged.eventName;

  constructor(readonly state: ConnectionState) {}
}
